export const FILTERLINE_HEIGHT = 100
export const DASHBOARD_HEADER_HEIGHT = 43
